import { BottomNavigationDesktop } from "./BottomNavigation.desktop";
import { FabDesktop } from "./Fab.desktop";
import { MainDesktop } from "./Main.desktop";
import { NavbarDesktop } from "./Navbar.desktop";

/**
 * Desktop layout with slot architecture.
 * Each UI slot (navbar, fab, bottomNav) subscribes independently,
 * so children never re-render when slots update.
 */
export function PageLayoutDesktop() {
  return (
    <div className="mx-auto flex h-dvh max-w-5xl flex-col">
      <NavbarDesktop />
      <MainDesktop />
      <FabDesktop />
      <BottomNavigationDesktop />
    </div>
  );
}
